import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';
import { getDateTimeOffsetName } from '../common/utils';

@Pipe({
  name: 'luxonOffsetNameShort',
  standalone: true,
})
export class LuxonOffsetNameShortPipe implements PipeTransform {
  transform(date: DateTime): string {
    return getDateTimeOffsetName(date);
  }
}
